import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import * as styles from '@twistopayments/design-system/styles';

export const root = css`
  margin-left: auto;
  margin-right: auto;

  padding-left: 20px;
  padding-right: 20px;

  width: 100%;
`;

export const sizes = {
  large: css`
    max-width: ${styles.width.container.large};
  `,
  wider: css`
    max-width: ${styles.width.container.wider};
  `,
  wide: css`
    max-width: ${styles.width.container.wide};
  `,
  standard: css`
    max-width: ${styles.width.container.standard};
  `,
  compact: css`
    max-width: ${styles.width.container.compact};
  `,
  small: css`
    max-width: ${styles.width.container.small};
  `,
  tiny: css`
    max-width: ${styles.width.container.tiny};
  `,
};

export const flex = css`
  display: flex;
`;

export const noPadding = css`
  padding-left: 0;
  padding-right: 0;
`;

export const fullHeight = (theme: Theme) => css`
  height: 100%;

  ${styles.breakpoint.down('sm')} {
    ${theme.presentation.surface.fullHeightMobile}
  }
`;

export const tinyOnMobile = (theme: Theme) => css`
  ${styles.breakpoint.down('sm')} {
    margin: ${theme.spacing[0]} auto;
    max-width: ${styles.width.container.tiny};
  }
`;
